import { render } from "./MapRegion.vue?vue&type=template&id=6f0d64be&scoped=true"
import script from "./MapRegion.vue?vue&type=script&lang=js"
export * from "./MapRegion.vue?vue&type=script&lang=js"

import "./MapRegion.vue?vue&type=style&index=0&id=6f0d64be&lang=scss&scoped=true"

import exportComponent from "C:\\agent\\_work\\39\\s\\Infosit.Cms.Web.v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f0d64be"]])

export default __exports__